import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "channel-sms",
  "use": "channel-sms-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"channel-sms\"><path d=\"M13.147 11.228a2.478 2.478 0 001.436-2.114c0-.93-.495-2.114-1.639-2.114M8.48 11.228a2.477 2.477 0 001.436-2.114C9.916 8.184 9.421 7 8.277 7m11.39 10h-9.334L5 21v-4H2.333A1.333 1.333 0 011 15.667V2.333C1 1.597 1.597 1 2.333 1h17.334C20.403 1 21 1.597 21 2.333v13.334c0 .736-.597 1.333-1.333 1.333zm-6-9.333a.667.667 0 10-1.334 0 .667.667 0 001.334 0zM9 7.667a.667.667 0 10-1.333 0 .667.667 0 001.333 0z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/channel-sms.svg
// module id = GJi+
// module chunks = 39 44